import 'client-only'
import {injectable} from 'inversify'
import type {
  ICurrentSessionResolver,
  SessionResolution,
} from '@/src/ports/services/current-session-resolver'

@injectable()
export class ClientCurrentSessionResolver implements ICurrentSessionResolver {
  async resolve(): Promise<SessionResolution> {
    return {session: null}
  }
}
